"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.naviDepositTx = naviDepositTx;
exports.naviWithdrawTx = naviWithdrawTx;
const transactions_1 = require("@mysten/sui/transactions");
const coins_js_1 = require("../common/coins.js");
const maps_js_1 = require("../common/maps.js");
const getReceipts_js_1 = require("../sui-sdk/functions/getReceipts.js");
const constants_js_1 = require("../common/constants.js");
const client_js_1 = require("../sui-sdk/client.js");
const naviOracle_js_1 = require("./naviOracle.js");
const get_navi_rewards_js_1 = require("./get_navi_rewards.js");
async function naviDepositTx(amount, poolName, options) {
    const C = (0, constants_js_1.getConf)();
    const suiClient = (0, client_js_1.getSuiClient)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const poolData = maps_js_1.poolInfo[poolName];
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    await (0, naviOracle_js_1.updateSingleTokenPrice)((0, client_js_1.getSuiClient)(), maps_js_1.naviPriceFeedMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin].pythPriceInfo, maps_js_1.naviPriceFeedMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin].feedId, txb);
    if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "SUI") {
        let someReceipt;
        if (receipt.length == 0) {
            [someReceipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [poolData.receiptType],
                arguments: [],
            });
        }
        else {
            [someReceipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [receipt[0].content.type],
                arguments: [txb.object(receipt[0].objectId)],
            });
        }
        const [depositCoin] = txb.splitCoins(txb.gas, [amount]);
        const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUI_ACCOUNT_ADDRESS);
        if (claimableRewards) {
            for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                : []) {
                if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap_bluefin`,
                        typeArguments: [
                            coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            coins_js_1.coinsList["NAVX"].type,
                        ],
                        arguments: [
                            txb.object(poolData.investorId),
                            txb.object(C.VERSION),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.NAVI_STORAGE),
                            txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V3),
                            txb.object(C.NAVI_NAVX_REWARDS_POOL),
                            txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                        ],
                    });
                }
                else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                    txb.moveCall({
                        target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap`,
                        typeArguments: [
                            coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            coins_js_1.coinsList["VSUI"].type,
                        ],
                        arguments: [
                            txb.object(poolData.investorId),
                            txb.object(C.VERSION),
                            txb.object(C.CLOCK_PACKAGE_ID),
                            txb.object(C.NAVI_STORAGE),
                            txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                            txb.object(C.NAVI_INCENTIVE_V3),
                            txb.object(C.NAVI_VSUI_REWARDS_POOL),
                            txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                            txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        ],
                    });
                }
            }
        }
        txb.moveCall({
            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
            typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
            arguments: [
                txb.object(C.VERSION),
                someReceipt,
                txb.object(poolData.poolId),
                depositCoin,
                txb.object(poolData.investorId),
                txb.object(C.ALPHA_DISTRIBUTOR),
                txb.object(C.PRICE_ORACLE),
                txb.object(C.NAVI_STORAGE),
                txb.object(poolData.parentPoolId),
                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                txb.object(C.NAVI_INCENTIVE_V3),
                txb.object(C.NAVI_INCENTIVE_V2),
                txb.object(C.CLOCK_PACKAGE_ID),
            ],
        });
    }
    else {
        let coins = [];
        let currentCursor = null;
        do {
            const response = await suiClient.getCoins({
                owner: address,
                coinType: coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                cursor: currentCursor,
            });
            coins = coins.concat(response.data);
            // Check if there's a next page
            if (response.hasNextPage && response.nextCursor) {
                currentCursor = response.nextCursor;
            }
            else {
                // No more pages available
                // console.log("No more receipts available.");
                break;
            }
        } while (true);
        if (coins.length >= 1) {
            const [coin] = txb.splitCoins(txb.object(coins[0].coinObjectId), [0]);
            txb.mergeCoins(coin, coins.map((c) => c.coinObjectId));
            const [depositCoin] = txb.splitCoins(coin, [amount]);
            let someReceipt;
            if (receipt.length == 0) {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::none`,
                    typeArguments: [poolData.receiptType],
                    arguments: [],
                });
            }
            else {
                [someReceipt] = txb.moveCall({
                    target: `0x1::option::some`,
                    typeArguments: [receipt[0].content.type],
                    arguments: [txb.object(receipt[0].objectId)],
                });
            }
            if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "VSUI") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_VSUI_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WETH" ||
                maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDT") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["WUSDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["WUSDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WUSDC") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["USDC"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(maps_js_1.bluefinPoolMap["NAVX-USDC"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-USDC`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin_v2`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["USDC"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(maps_js_1.bluefinPoolMap["VSUI-USDC"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-USDC`]),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDC") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDY") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["WUSDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["WUSDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(poolData.investorId),
                                    txb.object(C.VERSION),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "AUSD" ||
                maps_js_1.singleAssetPoolCoinMap[poolName].coin == "ETH") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["USDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`USDC-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NS") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_NS_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["DEEP-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["NS"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NS_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NS_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(maps_js_1.cetusPoolMap["NS-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-NAVX") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_NAVX_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NAVX_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-STSUI") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_STSUI_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["STSUI"].type) {
                            txb.moveCall({
                                target: `${poolData.packageId}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [coins_js_1.coinsList["STSUI"].type],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_STSUI_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_STSUI_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(maps_js_1.cetusPoolMap["STSUI-SUI"]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-SUIBTC") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUIBTC_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["NAVX"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["DEEP"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(maps_js_1.bluefinPoolMap["DEEP-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                        coins_js_1.coinsList["VSUI"].type,
                        coins_js_1.coinsList["NAVX"].type,
                        coins_js_1.coinsList["DEEP"].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_NAVI_V2_VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.CLOCK_PACKAGE_ID),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_NAVX_FUNDS_POOL),
                        txb.object(C.NAVI_DEEP_FUNDS_POOL),
                        txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                        txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["DEEP-SUI"]),
                        txb.object(maps_js_1.bluefinPoolMap["SUI-SUIBTC"]),
                        txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    ],
                });
                txb.moveCall({
                    target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit_v2`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_NAVI_V2_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "NAVI-SUIUSDT") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUIUSDT_ACCOUNT_ADDRESS);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["USDC"].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                                    txb.object(maps_js_1.cetusPoolMap[`USDC-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WAL") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : [
                            { rewardCoinType: coins_js_1.coinsList["WAL"].type },
                            { rewardCoinType: coins_js_1.coinsList["VSUI"].type },
                        ]) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["WAL"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_WAL_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "DEEP") {
                const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
                if (claimableRewards) {
                    for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                        : []) {
                        if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                        else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                            txb.moveCall({
                                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                                typeArguments: [
                                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                    coins_js_1.coinsList["SUI"].type,
                                    coins_js_1.coinsList["VSUI"].type,
                                ],
                                arguments: [
                                    txb.object(C.ALPHA_3_VERSION),
                                    txb.object(poolData.investorId),
                                    txb.object(C.NAVI_STORAGE),
                                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                    txb.object(C.NAVI_INCENTIVE_V3),
                                    txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                    txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                    txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                    txb.object(C.CLOCK_PACKAGE_ID),
                                ],
                            });
                        }
                    }
                }
                txb.moveCall({
                    target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_deposit`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    ],
                    arguments: [
                        txb.object(C.ALPHA_3_VERSION),
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V3),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else {
                txb.moveCall({
                    target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_deposit_with_two_swaps`,
                    typeArguments: [
                        coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                        coins_js_1.coinsList["SUI"].type,
                        coins_js_1.coinsList["VSUI"].type,
                    ],
                    arguments: [
                        txb.object(C.VERSION),
                        someReceipt,
                        txb.object(poolData.poolId),
                        depositCoin,
                        txb.object(poolData.investorId),
                        txb.object(C.ALPHA_DISTRIBUTOR),
                        txb.object(C.PRICE_ORACLE),
                        txb.object(C.NAVI_STORAGE),
                        txb.object(poolData.parentPoolId),
                        txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                        txb.object(C.NAVI_INCENTIVE_V1),
                        txb.object(C.NAVI_INCENTIVE_V2),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.NAVI_VSUI_FUNDS_POOL),
                        txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                        txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                        txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                        txb.object(C.CLOCK_PACKAGE_ID),
                    ],
                });
            }
            txb.transferObjects([coin], address);
        }
        else {
            throw new Error(`No ${maps_js_1.singleAssetPoolCoinMap[poolName].coin} Coins`);
        }
    }
    return txb;
}
async function naviWithdrawTx(xTokens, poolName, options) {
    const C = await (0, constants_js_1.getConf)();
    const address = options.address;
    const txb = new transactions_1.Transaction();
    poolName = poolName.toUpperCase();
    const poolData = maps_js_1.poolInfo[poolName];
    const receipt = await (0, getReceipts_js_1.getReceipts)(poolName, address, true);
    const alphaReceipt = await (0, getReceipts_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        let alpha_receipt;
        if (alphaReceipt.length == 0) {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [C.ALPHA_POOL_RECEIPT],
                arguments: [],
            });
        }
        else {
            [alpha_receipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [alphaReceipt[0].content.type],
                arguments: [txb.object(alphaReceipt[0].objectId)],
            });
        }
        await (0, naviOracle_js_1.updateSingleTokenPrice)((0, client_js_1.getSuiClient)(), maps_js_1.naviPriceFeedMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin].pythPriceInfo, maps_js_1.naviPriceFeedMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin].feedId, txb);
        if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "SUI") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_one_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "VSUI") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_VSUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WETH" ||
            maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDT") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["WUSDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["WUSDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WUSDC") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["CETUS"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["CETUS-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["CETUS"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["CETUS-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-CETUS`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDC") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "USDY") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["WUSDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_investor::collect_v3_rewards_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["WUSDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(poolData.investorId),
                                txb.object(C.VERSION),
                                txb.object(C.CLOCK_PACKAGE_ID),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["WUSDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-WUSDC`]),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "AUSD" ||
            maps_js_1.singleAssetPoolCoinMap[poolName].coin == "ETH") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["USDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`USDC-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-NS") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_NS_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["DEEP"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["DEEP-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["NS"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NS_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    coins_js_1.coinsList["SUI"].type,
                    coins_js_1.coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NS_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object(maps_js_1.cetusPoolMap["NS-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-NAVX") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_NAVX_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    coins_js_1.coinsList["SUI"].type,
                    coins_js_1.coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NAVX_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-STSUI") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_STSUI_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["STSUI"].type) {
                        txb.moveCall({
                            target: `${poolData.packageId}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [coins_js_1.coinsList["STSUI"].type],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_STSUI_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool_with_two_swaps_v2`,
                typeArguments: [
                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    coins_js_1.coinsList["SUI"].type,
                    coins_js_1.coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_STSUI_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object(maps_js_1.cetusPoolMap["STSUI-SUI"]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-SUIBTC") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUIBTC_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["NAVX"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(maps_js_1.bluefinPoolMap["NAVX-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["DEEP"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(maps_js_1.bluefinPoolMap["DEEP-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_NAVI_V2_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`SUI-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::update_pool`,
                typeArguments: [
                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    coins_js_1.coinsList["VSUI"].type,
                    coins_js_1.coinsList["NAVX"].type,
                    coins_js_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.CLOCK_PACKAGE_ID),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_NAVX_FUNDS_POOL),
                    txb.object(C.NAVI_DEEP_FUNDS_POOL),
                    txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                    txb.object(maps_js_1.cetusPoolMap["NAVX-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(maps_js_1.bluefinPoolMap["SUI-SUIBTC"]),
                    txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                ],
            });
            txb.moveCall({
                target: `${C.ALPHA_NAVI_V2_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw_v2`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_NAVI_V2_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "NAVI-SUIUSDT") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)((0, constants_js_1.getConf)().NAVI_SUIUSDT_ACCOUNT_ADDRESS);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["NAVX"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_NAVX_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_three_swaps`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["USDC"].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                                txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap["USDC-SUI"]),
                                txb.object(maps_js_1.cetusPoolMap[`USDC-${maps_js_1.singleAssetPoolCoinMap[poolName].coin}`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "WAL") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : [
                        { rewardCoinType: coins_js_1.coinsList["WAL"].type },
                        { rewardCoinType: coins_js_1.coinsList["VSUI"].type },
                    ]) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["WAL"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_WAL_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (maps_js_1.singleAssetPoolCoinMap[poolName].coin == "DEEP") {
            const claimableRewards = await (0, get_navi_rewards_js_1.getAvailableRewards)(maps_js_1.loopingAccountAddresses[poolName]);
            if (claimableRewards) {
                for (const reward of claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    ? claimableRewards[coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type]
                    : []) {
                    if (reward.rewardCoinType === coins_js_1.coinsList["DEEP"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_no_swap`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_DEEP_REWARDS_POOL),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                    else if (reward.rewardCoinType === coins_js_1.coinsList["VSUI"].type) {
                        txb.moveCall({
                            target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::collect_reward_with_two_swaps_bluefin`,
                            typeArguments: [
                                coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                                coins_js_1.coinsList["SUI"].type,
                                coins_js_1.coinsList["VSUI"].type,
                            ],
                            arguments: [
                                txb.object(C.ALPHA_3_VERSION),
                                txb.object(poolData.investorId),
                                txb.object(C.NAVI_STORAGE),
                                txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                                txb.object(C.NAVI_INCENTIVE_V3),
                                txb.object(C.NAVI_VSUI_REWARDS_POOL),
                                txb.object(C.BLUEFIN_GLOBAL_CONFIG),
                                txb.object(maps_js_1.bluefinPoolMap["VSUI-SUI"]),
                                txb.object(maps_js_1.bluefinPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                                txb.object(C.CLOCK_PACKAGE_ID),
                            ],
                        });
                    }
                }
            }
            txb.moveCall({
                target: `${C.ALPHA_3_LATEST_PACKAGE_ID}::alphafi_navi_pool_v2::user_withdraw`,
                typeArguments: [coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type],
                arguments: [
                    txb.object(C.ALPHA_3_VERSION),
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V3),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            txb.moveCall({
                target: `${C.ALPHA_LATEST_PACKAGE_ID}::alphafi_navi_pool::user_withdraw_with_two_swaps`,
                typeArguments: [
                    coins_js_1.coinsList[maps_js_1.singleAssetPoolCoinMap[poolName].coin].type,
                    coins_js_1.coinsList["SUI"].type,
                    coins_js_1.coinsList["VSUI"].type,
                ],
                arguments: [
                    txb.object(C.VERSION),
                    txb.object(receipt[0].objectId),
                    alpha_receipt,
                    txb.object(C.ALPHA_POOL),
                    txb.object(poolData.poolId),
                    txb.pure.u64(xTokens),
                    txb.object(poolData.investorId),
                    txb.object(C.ALPHA_DISTRIBUTOR),
                    txb.object(C.PRICE_ORACLE),
                    txb.object(C.NAVI_STORAGE),
                    txb.object(poolData.parentPoolId),
                    txb.pure.u8(Number(maps_js_1.naviAssetMap[maps_js_1.singleAssetPoolCoinMap[poolName].coin])),
                    txb.object(C.NAVI_INCENTIVE_V1),
                    txb.object(C.NAVI_INCENTIVE_V2),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.NAVI_VSUI_FUNDS_POOL),
                    txb.object(C.CETUS_GLOBAL_CONFIG_ID),
                    txb.object(maps_js_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object(maps_js_1.cetusPoolMap[`${maps_js_1.singleAssetPoolCoinMap[poolName].coin}-SUI`]),
                    txb.object(C.CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else {
        throw new Error(`No ${poolName} Receipt`);
    }
    return txb;
}
//# sourceMappingURL=navi.js.map